export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/fbf1cfaf74329f9a6a1fed67972e7c52.svg";